<template>
  <main class="main page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="content">
            <div class="confirmation-failed">
              <div class="confirmation-failed__icon">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="40" cy="40" r="40" fill="#FEF2F2"/>
                  <path d="M50.6667 29.3333L29.3333 50.6667M29.3333 29.3333L50.6667 50.6667" stroke="#EF4444" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <h1 class="confirmation-failed__title">{{ $t(failureTitle) }}</h1>
              <p class="confirmation-failed__message">{{ $t(failureMessage) }}</p>
              
              <div class="instruction-message" v-if="shouldShowInstructions">
                {{ $t(`Please return to the original browser tab where you initiated your transaction to try again.`) }}
              </div>
              
              <div class="buttons">
                <button class="button primary" @click="goToBuyCrypto">{{ $t(`Try Again`) }}</button>
                <button class="button secondary" @click="goToHome">{{ $t(`Go to Home`) }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'ConfirmationFailedPage',
  data() {
    return {
      failureReason: '',
      failureTitle: 'Confirmation Failed',
      failureMessage: 'We were unable to confirm your transaction. Please try again.'
    }
  },
  computed: {
    shouldShowInstructions() {
      // Show instructions for most failure cases
      return ['expired', 'invalid', 'no-order'].includes(this.failureReason);
    }
  },
  mounted() {
    // Get the reason from query parameters
    this.failureReason = this.$route.query.reason || '';
    
    // Set the appropriate message based on reason
    switch (this.failureReason) {
      case 'expired':
        this.failureTitle = 'Confirmation Expired';
        this.failureMessage = 'The confirmation link has expired. Please try creating a new transaction.';
        break;
      case 'invalid':
        this.failureTitle = 'Invalid Confirmation';
        this.failureMessage = 'The confirmation link is invalid or has been tampered with. Please try again.';
        break;
      case 'no-order':
        this.failureTitle = 'Order Not Found';
        this.failureMessage = 'We could not find the order associated with this confirmation. Please try creating a new transaction.';
        break;
      case 'outdated':
        this.failureTitle = 'Outdated Confirmation Link';
        this.failureMessage = 'This confirmation link is outdated. A newer confirmation link has been generated. Please check your email for the latest link or return to your transaction.';
        break;
      default:
        // Use default message
        break;
    }
  },
  methods: {
    goToHome() {
      this.$router.push({ path: '/' });
    },
    goToBuyCrypto() {
      this.$router.push({ path: '/buy-crypto' });
    }
  }
}
</script>

<style scoped>
.page-inside {
  line-height: 1;
}

.confirmation-failed {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: #FFFFFF;
  border-radius: 16px;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.confirmation-failed__icon {
  margin-bottom: 24px;
}

.confirmation-failed__title {
  font-size: 24px;
  font-weight: 700;
  color: #1E293B;
  margin-bottom: 16px;
}

.confirmation-failed__message {
  font-size: 16px;
  color: #64748B;
  margin-bottom: 16px;
  line-height: 1.5;
}

.instruction-message {
  font-size: 14px;
  color: #1E293B;
  margin-bottom: 32px;
  padding: 12px 16px;
  background-color: #F8FAFC;
  border-left: 3px solid #8C44AE;
  border-radius: 4px;
  text-align: left;
  width: 100%;
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.button {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.button.primary {
  background: #8C44AE;
  color: white;
  border: none;
}

.button.primary:hover {
  background: #7a399a;
}

.button.secondary {
  background: transparent;
  color: #8C44AE;
  border: 1px solid #8C44AE;
}

.button.secondary:hover {
  background: rgba(140, 68, 174, 0.1);
}

@media (max-width: 480px) {
  .confirmation-failed {
    padding: 30px 16px;
  }
  
  .confirmation-failed__title {
    font-size: 20px;
  }
  
  .confirmation-failed__message {
    font-size: 14px;
  }
  
  .instruction-message {
    font-size: 13px;
    padding: 10px 14px;
  }
}
</style> 